<script setup>
import { useStore } from "vuex";
import { ref, computed, onMounted, inject, watch } from "vue";
import { useRouter, useRoute } from "vue-router";
import useGtmEvent from "../use/useGtm";
import Stepper from "../components/Stepper";
import PanneauAide from "../components/partials/PanneauAide";
import Loader from "../components/components/Loader";
import FooterLeads from "../components/components/Footer.vue";
import etapesDictionnaire from "../dictionnaire/etapes";
import Header from "../components/components/Header.vue";

const store = useStore();
const router = useRouter();
const route = useRoute();
const { gtmEvent, gtmTrackView, gtmEventv4 } = useGtmEvent();

const loading = ref(false);
const version = ref(null);
const montrerAide = ref(false);
const slidePanelDirection = ref("left");

const opportunite = computed(() => store.getters.opportunite);

const etapes = computed(() => {
  if (opportunite.value.type === "PROFESSIONNEL") {
    return etapesDictionnaire.etapesPro;
  }
  return etapesDictionnaire.etapesParticulier;
});
function titreEtape(nomEtape) {
  if (opportunite.value.type === "PROFESSIONNEL") {
    return etapesDictionnaire.etapesPro.find(
      (etape) => etape.nom === nomEtape,
    ).libelle;
  }
  return etapesDictionnaire.etapesParticulier.find(
    (etape) => etape.nom === nomEtape,
  ).libelle;
}

function soumettreOpportunite() {
  const typeOpportunite = store.state.opportunite.type.toLowerCase();
  loading.value = true;

  gtmEvent(
    "leads-formulaire",
    `${typeOpportunite}-soumission`,
    "Soumission Ok",
    true,
  );
  store.dispatch('soumettreOpportunite')
    .then((opportuniteSoumise) => {
      gtmEvent(
        "leads-formulaire",
        `${typeOpportunite}-confirmation-soumission`,
        `Soumission Ok | ${opportuniteSoumise.id}`,
        true,
      );
      gtmEventv4({
        event_name: "comparatif_principal_soumission_formulaire",
        motivation: opportuniteSoumise.energie,
        user_data: store.getters.getContactSansGoogleClientId,
      });
      router.push(
        `/solution/${opportuniteSoumise.id}?version=${version.value}`,
      );
    })
    .catch((err) => {
      console.error(err);
      router.push(
        `/traitement/partiel/${err.codeErreur}?version=${version.value}`,
      );
    });
}

const togglePanneauAide = () => {
  montrerAide.value = !montrerAide.value;
  if (montrerAide.value === false) {
    slidePanelDirection.value = "right";
  } else {
    slidePanelDirection.value = "left";
  }
};

onMounted(() => {
  version.value = localStorage.version;
});

</script>
<template>
    <div class="mainContainer w-full relative">
        <Header titreApplication="Mon assistant comparateur" />
        <main class="conteneur-principal flex-grow">
            <div class="conteneur-stepper-principal">
                <router-view
                    name="sidebar"
                    v-slot="{ Component }">
                    <component
                        v-if="Component"
                        :is="Component"
                        class="hidden lg:flex"
                    />
                    <Stepper v-else :etapes="etapes" />
                </router-view>
            </div>
            <div class="conteneur-contenu overflow-y-auto">
                <div class="w-full lg:w-4/5 min-h-full flex flex-col justify-center">
                    <div class="libelle-active">
                        {{ titreEtape(route.meta.etape) }}
                    </div>
                    <router-view
                        @togglePanneauAide="togglePanneauAide"
                        @validerForm="soumettreOpportunite"
                    />
                </div>
            </div>
        </main>
        <FooterLeads
            v-if="
                route.name === 'raison-sociale' || route.name === 'particulier'
            "
        />
        <div
            class="dimmer"
            v-if="montrerAide === true"
            @click="togglePanneauAide"
            data-cy="dimmer"
        />
        <Transition :name="`slide-${slidePanelDirection}`" mode="out-in">
            <panneau-aide
                class="conteneur-aide"
                v-show="montrerAide"
                @toggle="togglePanneauAide()"
                data-cy="aide_mobile"
            >
                <router-view name="aide" />
            </panneau-aide>
        </Transition>
        <Loader v-if="loading" />
    </div>
</template>
